import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, Teleport as _Teleport, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-slate-500 mt-0.5"
};
const _hoisted_3 = {
  class: "flex-shrink-0 px-6 border-b border-slate-200"
};
const _hoisted_4 = {
  class: "flex gap-6"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "h-[60vh] overflow-y-auto"
};
const _hoisted_7 = {
  key: 0,
  class: "p-6"
};
const _hoisted_8 = {
  class: "flex items-center gap-4 mb-6"
};
const _hoisted_9 = {
  class: "text-xl font-semibold text-slate-900"
};
const _hoisted_10 = {
  class: "text-slate-500"
};
const _hoisted_11 = {
  class: "grid grid-cols-2 md:grid-cols-3 gap-4"
};
const _hoisted_12 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_13 = {
  class: "font-medium text-slate-900"
};
const _hoisted_14 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_15 = {
  class: "font-medium text-slate-900"
};
const _hoisted_16 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_17 = {
  class: "font-medium text-slate-900"
};
const _hoisted_18 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_19 = {
  class: "font-medium text-slate-900"
};
const _hoisted_20 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_21 = {
  class: "font-medium text-slate-900"
};
const _hoisted_22 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_23 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_24 = {
  class: "font-medium text-slate-900"
};
const _hoisted_25 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_26 = {
  class: "font-medium text-slate-900"
};
const _hoisted_27 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_28 = {
  class: "font-medium text-slate-900"
};
const _hoisted_29 = {
  class: "bg-slate-50 rounded-lg p-4 md:col-span-3"
};
const _hoisted_30 = {
  class: "font-medium text-slate-900"
};
const _hoisted_31 = {
  class: "bg-slate-50 rounded-lg p-4 md:col-span-3"
};
const _hoisted_32 = {
  class: "font-medium text-slate-900"
};
const _hoisted_33 = {
  class: "grid grid-cols-2 md:grid-cols-4 gap-4"
};
const _hoisted_34 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_35 = {
  class: "text-xl font-bold text-slate-900"
};
const _hoisted_36 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_37 = {
  class: "text-xl font-bold text-slate-900"
};
const _hoisted_38 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_39 = {
  class: "text-xl font-bold text-primary-600"
};
const _hoisted_40 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_41 = {
  class: "text-xl font-bold text-slate-900"
};
const _hoisted_42 = {
  key: 1,
  class: "p-6"
};
const _hoisted_43 = {
  class: "grid grid-cols-2 md:grid-cols-4 gap-4 mb-6"
};
const _hoisted_44 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_45 = {
  class: "text-xl font-bold text-slate-900"
};
const _hoisted_46 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_47 = {
  class: "text-xl font-bold text-slate-900"
};
const _hoisted_48 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_49 = {
  class: "text-xl font-bold text-primary-600"
};
const _hoisted_50 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_51 = {
  class: "text-xl font-bold text-slate-900"
};
const _hoisted_52 = {
  key: 2,
  class: "p-6"
};
const _hoisted_53 = {
  key: 0,
  class: "flex items-center justify-center py-12"
};
const _hoisted_54 = {
  key: 1,
  class: "py-12 text-center text-slate-400"
};
const _hoisted_55 = {
  key: 2,
  class: "space-y-3"
};
const _hoisted_56 = {
  class: "flex items-center justify-between mb-2"
};
const _hoisted_57 = {
  class: "flex items-center gap-3"
};
const _hoisted_58 = {
  class: "text-sm text-slate-500"
};
const _hoisted_59 = {
  class: "text-sm text-slate-500"
};
const _hoisted_60 = {
  class: "text-sm text-slate-700 mb-2"
};
const _hoisted_61 = {
  key: 0,
  class: "text-xs text-amber-600 bg-amber-50 p-2 rounded"
};
const _hoisted_62 = {
  key: 1,
  class: "mt-2 text-xs text-slate-500"
};
const _hoisted_63 = {
  key: 3,
  class: "p-6"
};
const _hoisted_64 = {
  class: "flex flex-wrap items-center justify-between gap-3 mb-4"
};
const _hoisted_65 = {
  class: "flex flex-wrap items-center justify-end gap-2"
};
const _hoisted_66 = {
  key: 0,
  class: "flex items-center justify-center py-12"
};
const _hoisted_67 = {
  key: 1,
  class: "space-y-6"
};
const _hoisted_68 = {
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_69 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_70 = {
  class: "text-sm text-slate-900"
};
const _hoisted_71 = {
  class: "text-sm text-slate-900"
};
const _hoisted_72 = {
  class: "text-sm text-slate-900 font-mono"
};
const _hoisted_73 = {
  class: "text-sm text-slate-900 font-mono"
};
const _hoisted_74 = {
  class: "text-sm text-slate-900 font-mono"
};
const _hoisted_75 = {
  class: "text-sm text-slate-900"
};
const _hoisted_76 = {
  key: 2,
  class: "flex flex-col items-center justify-center py-16 text-slate-500"
};
const _hoisted_77 = {
  class: "flex items-center justify-between px-6 py-4 bg-gradient-to-r from-slate-50 to-white border-b border-slate-100"
};
const _hoisted_78 = {
  class: "flex items-center gap-3"
};
const _hoisted_79 = {
  class: "text-xs text-slate-500"
};
const _hoisted_80 = {
  class: "p-6 space-y-4"
};
const _hoisted_81 = {
  class: "grid grid-cols-1 md:grid-cols-2 gap-4"
};
const _hoisted_82 = {
  class: "md:col-span-2"
};
const _hoisted_83 = {
  class: "px-6 py-4 bg-slate-50 border-t border-slate-100 flex justify-end gap-3"
};
const _hoisted_84 = ["disabled"];
const _hoisted_85 = ["disabled"];
const _hoisted_86 = {
  key: 0,
  class: "w-4 h-4 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
};
const _hoisted_87 = {
  class: "flex items-center justify-between px-6 py-4 bg-gradient-to-r from-slate-50 to-white border-b border-slate-100"
};
const _hoisted_88 = {
  class: "p-6"
};
const _hoisted_89 = {
  class: "space-y-4"
};
const _hoisted_90 = {
  class: "group"
};
const _hoisted_91 = {
  class: "group"
};
const _hoisted_92 = {
  class: "group"
};
const _hoisted_93 = {
  class: "group"
};
const _hoisted_94 = {
  class: "group"
};
const _hoisted_95 = {
  class: "px-6 py-4 bg-slate-50 border-t border-slate-100 flex justify-end gap-3"
};
const _hoisted_96 = ["disabled"];
const _hoisted_97 = {
  key: 0,
  class: "w-4 h-4 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
};
import { ref, reactive, computed, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { getFranchiseeVisitList, createFranchiseeVisit, manualCompleteLakalaMerchantApply } from '@/api';
import { getFranchiseeAccount } from '@/api/commission';
import FranchiseeAccountFormModal from './FranchiseeAccountFormModal.vue';
import FranchiseePlatformReceiverBindModal from './FranchiseePlatformReceiverBindModal.vue';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'FranchiseeDetailModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    franchiseeId: {
      type: [Number, String],
      default: null
    },
    franchiseeInfo: {
      type: Object,
      default: null
    },
    initialTab: {
      type: String,
      default: 'basic'
    }
  },
  emits: ['update:visible', 'open-platform-receiver'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;

    // Tab 配置
    const tabs = computed(() => [{
      key: 'basic',
      label: '基本信息',
      count: null
    }, {
      key: 'performance',
      label: '业绩数据',
      count: null
    }, {
      key: 'visits',
      label: '回访记录',
      count: visits.value.length
    }, {
      key: 'bank',
      label: '分账账户',
      count: franchiseeAccount.value ? 1 : null
    }]);
    const isLedgerNotApplied = computed(() => {
      const account = franchiseeAccount.value;
      return !!account && !account.applyId && (!account.ledgerStatus || account.ledgerStatus === 'NOT_APPLIED');
    });
    const isLedgerPending = computed(() => franchiseeAccount.value?.ledgerStatus === 'PENDING');
    const isLedgerRejected = computed(() => franchiseeAccount.value?.ledgerStatus === 'INVALID');
    const canBindPlatformReceiver = computed(() => {
      const account = franchiseeAccount.value;
      return account?.ledgerStatus === 'VALID' && account?.bindStatus !== 0 && account?.bindStatus !== 1 && account?.bindStatus !== 3;
    });
    const accountPrimaryActionText = computed(() => franchiseeAccount.value ? '申请开通分账' : '补录商户信息');
    const platformBindActionText = computed(() => {
      const status = franchiseeAccount.value?.bindStatus;
      if (status === 0) return '绑定审核中';
      if (status === 1) return '已绑定平台';
      if (status === 3) return '解绑审核中';
      return '绑定平台接收方';
    });
    const accountEditActionText = computed(() => {
      if (isLedgerPending.value) return '审核中';
      if (isLedgerRejected.value) return '重新提交审核';
      return '编辑账户';
    });
    const activeTab = ref('basic');

    // 状态映射
    const statusTextMap = {
      0: '潜在加盟商',
      1: '意向加盟商',
      2: '签约审核中',
      3: '正式加盟商',
      4: '暂停',
      5: '终止'
    };
    const levelTextMap = {
      0: '普通加盟商',
      1: '银牌加盟商',
      2: '金牌加盟商',
      3: '钻石加盟商'
    };
    const visitTypeTextMap = {
      0: '电话',
      1: '微信',
      2: '上门',
      3: '邮件',
      4: '其他'
    };

    // 回访记录
    const visits = ref([]);
    const visitsLoading = ref(false);

    // 银行账户
    const franchiseeAccount = ref(null);
    const bankLoading = ref(false);
    const showAccountForm = ref(false);
    const editingAccount = ref(null);
    const showPlatformBindModal = ref(false);
    const showManualCompleteModal = ref(false);
    const manualCompleteSubmitting = ref(false);
    const manualCompleteForm = reactive({
      merInnerNo: '',
      merchantNo: '',
      termNo: '',
      contractId: '',
      orgCode: ''
    });

    // 回访弹窗
    const showVisitModal = ref(false);
    const visitSubmitting = ref(false);
    const visitForm = reactive({
      visitType: 0,
      content: '',
      visitTime: '',
      nextVisitTime: '',
      issues: ''
    });

    // 格式化日期
    const formatDate = dateStr => {
      if (!dateStr) return '-';
      return new Date(dateStr).toLocaleDateString('zh-CN');
    };
    const formatDateTime = dateStr => {
      if (!dateStr) return '-';
      return new Date(dateStr).toLocaleString('zh-CN');
    };

    // 获取状态文本
    const getStatusText = status => {
      return statusTextMap[status] || '未知';
    };

    // 获取等级文本
    const getLevelText = level => {
      return levelTextMap[level] || '未知';
    };

    // 获取回访方式文本
    const getVisitTypeText = type => {
      return visitTypeTextMap[type] || '未知';
    };

    // 获取状态样式
    const getStatusClass = status => {
      const classes = {
        0: 'status-badge is-neutral',
        1: 'status-badge is-info',
        2: 'status-badge is-warning',
        3: 'status-badge is-success',
        4: 'status-badge is-danger',
        5: 'status-badge is-neutral'
      };
      return classes[status] || 'status-badge is-neutral';
    };

    // 获取等级样式
    const getLevelClass = level => {
      const classes = {
        0: 'status-badge is-neutral',
        1: 'bg-slate-200 text-slate-700',
        2: 'status-badge is-warning',
        3: 'status-badge is-purple'
      };
      return classes[level] || 'status-badge is-neutral';
    };

    // 获取回访方式样式
    const getVisitTypeClass = type => {
      const classes = {
        0: 'status-badge is-info',
        1: 'status-badge is-success',
        2: 'status-badge is-warning',
        3: 'status-badge is-neutral',
        4: 'status-badge is-neutral'
      };
      return classes[type] || 'status-badge is-neutral';
    };

    // 加载回访记录
    const loadVisits = async () => {
      if (!props.franchiseeId) return;
      visitsLoading.value = true;
      try {
        visits.value = await getFranchiseeVisitList(props.franchiseeId);
      } catch (error) {
        console.error('获取回访记录失败:', error);
        visits.value = [];
      } finally {
        visitsLoading.value = false;
      }
    };

    // 加载加盟商分账账户
    const loadFranchiseeAccount = async () => {
      franchiseeAccount.value = null;
      if (!props.franchiseeId) return;
      bankLoading.value = true;
      try {
        franchiseeAccount.value = await getFranchiseeAccount(props.franchiseeId);
      } catch (error) {
        console.error('获取分账账户失败:', error);
        franchiseeAccount.value = null;
      } finally {
        bankLoading.value = false;
      }
    };

    // 创建账户
    const handleCreateAccount = () => {
      if (!franchiseeAccount.value) {
        ElMessage.warning('请先完成拉卡拉商户进件或人工补录商户信息');
        openManualCompleteModal();
        return;
      }
      editingAccount.value = isLedgerNotApplied.value ? {
        ...franchiseeAccount.value
      } : null;
      showAccountForm.value = true;
    };

    // 编辑账户
    const handleEditAccount = () => {
      if (isLedgerPending.value) {
        ElMessage.warning('当前有正在进行中的分账审核，请等待审核完成');
        return;
      }
      editingAccount.value = {
        ...franchiseeAccount.value
      };
      showAccountForm.value = true;
    };

    // 账户操作成功
    const handleAccountSuccess = () => {
      loadFranchiseeAccount();
    };
    const handleBindPlatformReceiver = () => {
      if (!canBindPlatformReceiver.value) {
        ElMessage.warning(platformBindActionText.value);
        return;
      }
      showPlatformBindModal.value = true;
    };
    const handleOpenPlatformReceiver = () => {
      emit('open-platform-receiver');
    };
    const handlePlatformBindSuccess = () => {
      loadFranchiseeAccount();
    };

    // 人工补录商户进件结果
    const resetManualCompleteForm = () => {
      Object.assign(manualCompleteForm, {
        merInnerNo: franchiseeAccount.value?.merInnerNo || '',
        merchantNo: franchiseeAccount.value?.merchantNo || '',
        termNo: franchiseeAccount.value?.termNo || '',
        contractId: '',
        orgCode: franchiseeAccount.value?.orgCode || ''
      });
    };
    const openManualCompleteModal = () => {
      resetManualCompleteForm();
      showManualCompleteModal.value = true;
    };
    const closeManualCompleteModal = () => {
      if (manualCompleteSubmitting.value) return;
      showManualCompleteModal.value = false;
    };
    const buildManualCompletePayload = () => {
      return Object.entries(manualCompleteForm).reduce((payload, [key, value]) => {
        if (typeof value === 'string' && value.trim()) {
          payload[key] = value.trim();
        }
        return payload;
      }, {});
    };
    const handleManualCompleteSubmit = async () => {
      if (!props.franchiseeId) {
        ElMessage.warning('缺少加盟商ID');
        return;
      }
      if (!manualCompleteForm.merInnerNo.trim()) {
        ElMessage.warning('请输入拉卡拉内部商户号');
        return;
      }
      if (!manualCompleteForm.merchantNo.trim()) {
        ElMessage.warning('请输入银联商户号');
        return;
      }
      if (!manualCompleteForm.termNo.trim()) {
        ElMessage.warning('请输入拉卡拉终端号');
        return;
      }
      manualCompleteSubmitting.value = true;
      try {
        await manualCompleteLakalaMerchantApply(props.franchiseeId, buildManualCompletePayload());
        ElMessage.success('人工补录成功');
        showManualCompleteModal.value = false;
        loadFranchiseeAccount();
      } catch (error) {
        console.error('人工补录商户信息失败:', error);
        ElMessage.error(error.message || '人工补录失败');
      } finally {
        manualCompleteSubmitting.value = false;
      }
    };

    // 打开回访弹窗
    const openVisitModal = () => {
      Object.assign(visitForm, {
        visitType: 0,
        content: '',
        visitTime: '',
        nextVisitTime: '',
        issues: ''
      });
      showVisitModal.value = true;
    };

    // 创建回访记录
    const handleCreateVisit = async () => {
      if (!visitForm.content.trim()) {
        ElMessage.warning('请输入回访内容');
        return;
      }
      visitSubmitting.value = true;
      try {
        await createFranchiseeVisit({
          franchiseeId: props.franchiseeId,
          ...visitForm
        });
        ElMessage.success('回访记录已保存');
        showVisitModal.value = false;
        loadVisits();
      } catch (error) {
        console.error('创建回访记录失败:', error);
        ElMessage.error(error.message || '创建回访记录失败');
      } finally {
        visitSubmitting.value = false;
      }
    };

    // 关闭弹窗
    const handleClose = () => {
      showManualCompleteModal.value = false;
      showPlatformBindModal.value = false;
      emit('update:visible', false);
    };

    // 监听 Tab 切换
    watch(activeTab, tab => {
      if (tab === 'visits' && visits.value.length === 0) {
        loadVisits();
      } else if (tab === 'bank' && !franchiseeAccount.value) {
        loadFranchiseeAccount();
      }
    });

    // 监听弹窗显示
    watch(() => props.visible, val => {
      if (val) {
        // 重置状态
        visits.value = [];
        franchiseeAccount.value = null;
        showManualCompleteModal.value = false;
        showPlatformBindModal.value = false;
        activeTab.value = props.initialTab || 'basic';
        if (activeTab.value === 'bank') {
          loadFranchiseeAccount();
        }
      }
    });
    watch(() => props.initialTab, tab => {
      if (props.visible && tab) {
        activeTab.value = tab;
        if (tab === 'bank' && !franchiseeAccount.value) {
          loadFranchiseeAccount();
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: __props.visible,
        size: "5xl",
        onClose: handleClose
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_cache[15] || (_cache[15] = _createElementVNode("h3", {
          class: "text-lg font-semibold text-slate-900"
        }, "加盟商详情", -1)), __props.franchiseeInfo ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.franchiseeInfo.name), 1)) : _createCommentVNode("", true)]), _createElementVNode("button", {
          onClick: handleClose,
          class: "p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
        }, [...(_cache[16] || (_cache[16] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("nav", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, tab => {
          return _openBlock(), _createElementBlock("button", {
            key: tab.key,
            onClick: $event => activeTab.value = tab.key,
            class: _normalizeClass(["py-3 text-sm font-medium border-b-2 transition-colors", activeTab.value === tab.key ? 'text-primary-600 border-primary-600' : 'text-slate-500 border-transparent hover:text-slate-700'])
          }, [_createTextVNode(_toDisplayString(tab.label) + " ", 1), tab.count !== undefined && tab.count !== null ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["ml-1.5 px-1.5 py-0.5 text-xs rounded-full", activeTab.value === tab.key ? 'bg-primary-100 text-primary-600' : 'bg-slate-100 text-slate-600'])
          }, _toDisplayString(tab.count), 3)) : _createCommentVNode("", true)], 10, _hoisted_5);
        }), 128))])]), _createElementVNode("div", _hoisted_6, [activeTab.value === 'basic' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[17] || (_cache[17] = _createElementVNode("div", {
          class: "w-16 h-16 bg-primary-100 rounded-xl flex items-center justify-center"
        }, [_createElementVNode("svg", {
          class: "w-8 h-8 text-primary-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
        })])], -1)), _createElementVNode("div", null, [_createElementVNode("h4", _hoisted_9, _toDisplayString(__props.franchiseeInfo?.name), 1), _createElementVNode("p", _hoisted_10, _toDisplayString(__props.franchiseeInfo?.franchiseeNo || '-'), 1)]), _createElementVNode("span", {
          class: _normalizeClass(['ml-auto px-3 py-1 rounded-full text-sm font-medium', getStatusClass(__props.franchiseeInfo?.status)])
        }, _toDisplayString(__props.franchiseeInfo?.statusDesc || getStatusText(__props.franchiseeInfo?.status)), 3)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_cache[18] || (_cache[18] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "负责人", -1)), _createElementVNode("div", _hoisted_13, _toDisplayString(__props.franchiseeInfo?.ownerUserName || '-'), 1)]), _createElementVNode("div", _hoisted_14, [_cache[19] || (_cache[19] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "所属部门", -1)), _createElementVNode("div", _hoisted_15, _toDisplayString(__props.franchiseeInfo?.ownerDeptName || '-'), 1)]), _createElementVNode("div", _hoisted_16, [_cache[20] || (_cache[20] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "联系电话", -1)), _createElementVNode("div", _hoisted_17, _toDisplayString(__props.franchiseeInfo?.phone || '-'), 1)]), _createElementVNode("div", _hoisted_18, [_cache[21] || (_cache[21] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "大区域", -1)), _createElementVNode("div", _hoisted_19, _toDisplayString(__props.franchiseeInfo?.majorRegion || '-'), 1)]), _createElementVNode("div", _hoisted_20, [_cache[22] || (_cache[22] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "小区域", -1)), _createElementVNode("div", _hoisted_21, _toDisplayString(__props.franchiseeInfo?.minorRegion || '-'), 1)]), _createElementVNode("div", _hoisted_22, [_cache[23] || (_cache[23] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "加盟等级", -1)), _createElementVNode("span", {
          class: _normalizeClass(['px-2 py-1 rounded text-xs font-medium', getLevelClass(__props.franchiseeInfo?.level)])
        }, _toDisplayString(__props.franchiseeInfo?.levelDesc || getLevelText(__props.franchiseeInfo?.level)), 3)]), _createElementVNode("div", _hoisted_23, [_cache[24] || (_cache[24] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "加盟日期", -1)), _createElementVNode("div", _hoisted_24, _toDisplayString(formatDate(__props.franchiseeInfo?.joinDate)), 1)]), _createElementVNode("div", _hoisted_25, [_cache[25] || (_cache[25] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "到期日期", -1)), _createElementVNode("div", _hoisted_26, _toDisplayString(formatDate(__props.franchiseeInfo?.expireDate)), 1)]), _createElementVNode("div", _hoisted_27, [_cache[26] || (_cache[26] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "保证金", -1)), _createElementVNode("div", _hoisted_28, "¥" + _toDisplayString((__props.franchiseeInfo?.deposit || 0).toLocaleString()), 1)]), _createElementVNode("div", _hoisted_29, [_cache[27] || (_cache[27] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "详细地址", -1)), _createElementVNode("div", _hoisted_30, _toDisplayString(__props.franchiseeInfo?.address || '-'), 1)]), _createElementVNode("div", _hoisted_31, [_cache[28] || (_cache[28] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "备注", -1)), _createElementVNode("div", _hoisted_32, _toDisplayString(__props.franchiseeInfo?.remark || '-'), 1)])]), _cache[33] || (_cache[33] = _createElementVNode("h5", {
          class: "text-lg font-medium text-slate-900 mt-6 mb-4"
        }, "业绩统计", -1)), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_cache[29] || (_cache[29] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "客户数量", -1)), _createElementVNode("div", _hoisted_35, _toDisplayString(__props.franchiseeInfo?.customerCount || 0), 1)]), _createElementVNode("div", _hoisted_36, [_cache[30] || (_cache[30] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "订单数量", -1)), _createElementVNode("div", _hoisted_37, _toDisplayString(__props.franchiseeInfo?.orderCount || 0), 1)]), _createElementVNode("div", _hoisted_38, [_cache[31] || (_cache[31] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "业绩金额", -1)), _createElementVNode("div", _hoisted_39, "¥" + _toDisplayString((__props.franchiseeInfo?.performanceAmount || 0).toLocaleString()), 1)]), _createElementVNode("div", _hoisted_40, [_cache[32] || (_cache[32] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "最后回访", -1)), _createElementVNode("div", _hoisted_41, _toDisplayString(formatDate(__props.franchiseeInfo?.lastVisitTime)), 1)])])])) : activeTab.value === 'performance' ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_cache[34] || (_cache[34] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "客户数量", -1)), _createElementVNode("div", _hoisted_45, _toDisplayString(__props.franchiseeInfo?.customerCount || 0), 1)]), _createElementVNode("div", _hoisted_46, [_cache[35] || (_cache[35] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "订单数量", -1)), _createElementVNode("div", _hoisted_47, _toDisplayString(__props.franchiseeInfo?.orderCount || 0), 1)]), _createElementVNode("div", _hoisted_48, [_cache[36] || (_cache[36] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "业绩金额", -1)), _createElementVNode("div", _hoisted_49, "¥" + _toDisplayString((__props.franchiseeInfo?.performanceAmount || 0).toLocaleString()), 1)]), _createElementVNode("div", _hoisted_50, [_cache[37] || (_cache[37] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "待回访", -1)), _createElementVNode("div", _hoisted_51, _toDisplayString(__props.franchiseeInfo?.nextVisitTime ? formatDate(__props.franchiseeInfo.nextVisitTime) : '无'), 1)])]), _cache[38] || (_cache[38] = _createElementVNode("div", {
          class: "h-64 bg-slate-50 rounded-lg flex items-center justify-center text-slate-400"
        }, " 业绩趋势图表区域 ", -1))])) : activeTab.value === 'visits' ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_createElementVNode("div", {
          class: "mb-4 flex justify-between items-center"
        }, [_cache[40] || (_cache[40] = _createElementVNode("h4", {
          class: "text-sm font-medium text-slate-700"
        }, "回访记录", -1)), _createElementVNode("button", {
          onClick: openVisitModal,
          class: "flex items-center gap-2 px-3 py-1.5 bg-primary-50 text-primary-600 rounded-lg hover:bg-primary-100 text-sm"
        }, [...(_cache[39] || (_cache[39] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1), _createTextVNode(" 添加回访 ", -1)]))])]), visitsLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_53, [...(_cache[41] || (_cache[41] = [_createElementVNode("div", {
          class: "w-8 h-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin"
        }, null, -1)]))])) : visits.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_54, " 暂无回访记录 ")) : (_openBlock(), _createElementBlock("div", _hoisted_55, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visits.value, visit => {
          return _openBlock(), _createElementBlock("div", {
            key: visit.id,
            class: "border border-slate-200 rounded-lg p-4"
          }, [_createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [_createElementVNode("span", {
            class: _normalizeClass(['px-2 py-0.5 rounded text-xs', getVisitTypeClass(visit.visitType)])
          }, _toDisplayString(visit.visitTypeDesc || getVisitTypeText(visit.visitType)), 3), _createElementVNode("span", _hoisted_58, _toDisplayString(formatDateTime(visit.visitTime)), 1)]), _createElementVNode("span", _hoisted_59, "回访人: " + _toDisplayString(visit.visitUserName || '-'), 1)]), _createElementVNode("div", _hoisted_60, _toDisplayString(visit.content), 1), visit.issues ? (_openBlock(), _createElementBlock("div", _hoisted_61, " 问题/需求: " + _toDisplayString(visit.issues), 1)) : _createCommentVNode("", true), visit.nextVisitTime ? (_openBlock(), _createElementBlock("div", _hoisted_62, " 下次回访: " + _toDisplayString(formatDateTime(visit.nextVisitTime)), 1)) : _createCommentVNode("", true)]);
        }), 128))]))])) : activeTab.value === 'bank' ? (_openBlock(), _createElementBlock("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [_cache[47] || (_cache[47] = _createElementVNode("h4", {
          class: "text-base font-medium text-slate-900"
        }, "分账账户信息", -1)), _createElementVNode("div", _hoisted_65, [_createElementVNode("button", {
          onClick: openManualCompleteModal,
          class: "btn-secondary"
        }, [...(_cache[42] || (_cache[42] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414A1 1 0 0119 9.414V19a2 2 0 01-2 2z"
        })], -1), _createTextVNode(" 人工补录商户 ", -1)]))]), _withDirectives((_openBlock(), _createElementBlock("button", {
          onClick: handleOpenPlatformReceiver,
          class: "btn-secondary"
        }, [...(_cache[43] || (_cache[43] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M17 9V7a4 4 0 00-8 0v2M5 11h14l-1 10H6L5 11z"
        })], -1), _createTextVNode(" 平台分账账户 ", -1)]))])), [[_directive_permission, 'commission:platform-receiver:query']]), franchiseeAccount.value ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: handleBindPlatformReceiver,
          class: _normalizeClass(["btn-secondary", {
            'opacity-60 cursor-not-allowed': !canBindPlatformReceiver.value
          }])
        }, [_cache[44] || (_cache[44] = _createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M13.828 10.172a4 4 0 010 5.656l-1.414 1.414a4 4 0 01-5.656-5.656l1.414-1.414m7.07-2.828a4 4 0 00-5.656 0L8.172 8.758a4 4 0 005.656 5.656l1.414-1.414"
        })], -1)), _createTextVNode(" " + _toDisplayString(platformBindActionText.value), 1)], 2)) : _createCommentVNode("", true), !franchiseeAccount.value || isLedgerNotApplied.value ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: handleCreateAccount,
          class: "btn-primary"
        }, [_cache[45] || (_cache[45] = _createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1)), _createTextVNode(" " + _toDisplayString(accountPrimaryActionText.value), 1)])) : (_openBlock(), _createElementBlock("button", {
          key: 2,
          onClick: handleEditAccount,
          class: _normalizeClass(["btn-primary", {
            'opacity-60 cursor-not-allowed': isLedgerPending.value
          }])
        }, [_cache[46] || (_cache[46] = _createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
        })], -1)), _createTextVNode(" " + _toDisplayString(accountEditActionText.value), 1)], 2))])]), bankLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_66, [...(_cache[48] || (_cache[48] = [_createElementVNode("div", {
          class: "w-8 h-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin"
        }, null, -1)]))])) : franchiseeAccount.value ? (_openBlock(), _createElementBlock("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_cache[55] || (_cache[55] = _createElementVNode("h4", {
          class: "text-sm font-medium text-slate-700 mb-4"
        }, "基本信息", -1)), _createElementVNode("div", _hoisted_69, [_createElementVNode("div", null, [_cache[49] || (_cache[49] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "商户名称", -1)), _createElementVNode("div", _hoisted_70, _toDisplayString(franchiseeAccount.value.payeeName || '-'), 1)]), _createElementVNode("div", null, [_cache[50] || (_cache[50] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "联系电话", -1)), _createElementVNode("div", _hoisted_71, _toDisplayString(franchiseeAccount.value.contactMobile || '-'), 1)]), _createElementVNode("div", null, [_cache[51] || (_cache[51] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "拉卡拉商户号", -1)), _createElementVNode("div", _hoisted_72, _toDisplayString(franchiseeAccount.value.merchantNo || '-'), 1)]), _createElementVNode("div", null, [_cache[52] || (_cache[52] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "拉卡拉终端号", -1)), _createElementVNode("div", _hoisted_73, _toDisplayString(franchiseeAccount.value.termNo || '-'), 1)]), _createElementVNode("div", null, [_cache[53] || (_cache[53] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "内部商户号", -1)), _createElementVNode("div", _hoisted_74, _toDisplayString(franchiseeAccount.value.merInnerNo || '-'), 1)]), _createElementVNode("div", null, [_cache[54] || (_cache[54] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "账户类型", -1)), _createElementVNode("div", _hoisted_75, _toDisplayString(franchiseeAccount.value.acctTypeCode === '57' ? '对公账户' : franchiseeAccount.value.acctTypeCode === '58' ? '对私账户' : '-'), 1)])])])])) : (_openBlock(), _createElementBlock("div", _hoisted_76, [_cache[56] || (_cache[56] = _createElementVNode("svg", {
          class: "w-20 h-20 text-slate-300 mb-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "1.5",
          d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
        })], -1)), _cache[57] || (_cache[57] = _createElementVNode("span", {
          class: "text-lg mb-2"
        }, "暂无分账账户", -1)), _cache[58] || (_cache[58] = _createElementVNode("span", {
          class: "text-sm"
        }, "请先完成拉卡拉商户进件，或人工补录已进件通过的商户信息", -1)), _createElementVNode("button", {
          onClick: openManualCompleteModal,
          class: "btn-secondary mt-4"
        }, " 人工补录商户 ")]))])) : _createCommentVNode("", true)]), _createElementVNode("div", {
          class: "flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-2xl"
        }, [_createElementVNode("button", {
          onClick: handleClose,
          class: "px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-100 transition-colors"
        }, " 关闭 ")])]),
        _: 1
      }, 8, ["visible"]), _createVNode(FranchiseeAccountFormModal, {
        visible: showAccountForm.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = $event => showAccountForm.value = $event),
        "franchisee-id": __props.franchiseeId,
        "account-data": editingAccount.value,
        onSuccess: handleAccountSuccess
      }, null, 8, ["visible", "franchisee-id", "account-data"]), _createVNode(FranchiseePlatformReceiverBindModal, {
        visible: showPlatformBindModal.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = $event => showPlatformBindModal.value = $event),
        "franchisee-id": __props.franchiseeId,
        "franchisee-info": __props.franchiseeInfo,
        account: franchiseeAccount.value,
        onSuccess: handlePlatformBindSuccess
      }, null, 8, ["visible", "franchisee-id", "franchisee-info", "account"]), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: showManualCompleteModal.value,
        size: "xl",
        onClose: closeManualCompleteModal
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_77, [_createElementVNode("div", _hoisted_78, [_cache[60] || (_cache[60] = _createElementVNode("div", {
          class: "w-10 h-10 bg-gradient-to-br from-primary-100 to-primary-50 rounded-xl flex items-center justify-center"
        }, [_createElementVNode("svg", {
          class: "w-5 h-5 text-primary-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414A1 1 0 0119 9.414V19a2 2 0 01-2 2z"
        })])], -1)), _createElementVNode("div", null, [_cache[59] || (_cache[59] = _createElementVNode("h3", {
          class: "text-lg font-semibold text-slate-900"
        }, "人工补录商户", -1)), _createElementVNode("p", _hoisted_79, _toDisplayString(__props.franchiseeInfo?.name || '-'), 1)])]), _createElementVNode("button", {
          onClick: closeManualCompleteModal,
          class: "p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-all duration-200"
        }, [...(_cache[61] || (_cache[61] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_80, [_cache[67] || (_cache[67] = _createElementVNode("div", {
          class: "rounded-lg bg-amber-50 border border-amber-100 px-4 py-3 text-sm text-amber-800"
        }, " 仅录入拉卡拉侧已完成进件后的商户结果信息。 ", -1)), _createElementVNode("div", _hoisted_81, [_createElementVNode("div", _hoisted_82, [_cache[62] || (_cache[62] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, [_createTextVNode("内部商户号 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => manualCompleteForm.merInnerNo = $event),
          class: "form-input w-full font-mono",
          placeholder: "请输入拉卡拉内部商户号"
        }, null, 512), [[_vModelText, manualCompleteForm.merInnerNo, void 0, {
          trim: true
        }]])]), _createElementVNode("div", null, [_cache[63] || (_cache[63] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, [_createTextVNode("银联商户号 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => manualCompleteForm.merchantNo = $event),
          class: "form-input w-full font-mono",
          placeholder: "请输入银联商户号"
        }, null, 512), [[_vModelText, manualCompleteForm.merchantNo, void 0, {
          trim: true
        }]])]), _createElementVNode("div", null, [_cache[64] || (_cache[64] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, [_createTextVNode("终端号 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => manualCompleteForm.termNo = $event),
          class: "form-input w-full font-mono",
          placeholder: "请输入拉卡拉终端号"
        }, null, 512), [[_vModelText, manualCompleteForm.termNo, void 0, {
          trim: true
        }]])]), _createElementVNode("div", null, [_cache[65] || (_cache[65] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, "进件ID", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => manualCompleteForm.contractId = $event),
          class: "form-input w-full",
          placeholder: "可选"
        }, null, 512), [[_vModelText, manualCompleteForm.contractId, void 0, {
          trim: true
        }]])]), _createElementVNode("div", null, [_cache[66] || (_cache[66] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, "机构代码", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => manualCompleteForm.orgCode = $event),
          class: "form-input w-full",
          placeholder: "可选"
        }, null, 512), [[_vModelText, manualCompleteForm.orgCode, void 0, {
          trim: true
        }]])])])]), _createElementVNode("div", _hoisted_83, [_createElementVNode("button", {
          onClick: closeManualCompleteModal,
          class: "btn-secondary",
          disabled: manualCompleteSubmitting.value
        }, " 取消 ", 8, _hoisted_84), _createElementVNode("button", {
          onClick: handleManualCompleteSubmit,
          class: "btn-primary",
          disabled: manualCompleteSubmitting.value
        }, [manualCompleteSubmitting.value ? (_openBlock(), _createElementBlock("svg", _hoisted_86, [...(_cache[68] || (_cache[68] = [_createElementVNode("circle", {
          class: "opacity-25",
          cx: "12",
          cy: "12",
          r: "10",
          stroke: "currentColor",
          "stroke-width": "4"
        }, null, -1), _createElementVNode("path", {
          class: "opacity-75",
          fill: "currentColor",
          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        }, null, -1)]))])) : _createCommentVNode("", true), _cache[69] || (_cache[69] = _createTextVNode(" 保存补录 ", -1))], 8, _hoisted_85)])]),
        _: 1
      }, 8, ["visible"])])), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: showVisitModal.value,
        size: "lg",
        onClose: _cache[14] || (_cache[14] = $event => showVisitModal.value = false)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_87, [_cache[71] || (_cache[71] = _createElementVNode("div", {
          class: "flex items-center gap-3"
        }, [_createElementVNode("div", {
          class: "w-10 h-10 bg-gradient-to-br from-primary-100 to-primary-50 rounded-xl flex items-center justify-center"
        }, [_createElementVNode("svg", {
          class: "w-5 h-5 text-primary-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
        })])]), _createElementVNode("div", null, [_createElementVNode("h3", {
          class: "text-lg font-semibold text-slate-900"
        }, "添加回访记录"), _createElementVNode("p", {
          class: "text-xs text-slate-500"
        }, "记录回访信息")])], -1)), _createElementVNode("button", {
          onClick: _cache[7] || (_cache[7] = $event => showVisitModal.value = false),
          class: "p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-all duration-200"
        }, [...(_cache[70] || (_cache[70] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, [_createElementVNode("div", _hoisted_90, [_cache[72] || (_cache[72] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, [_createTextVNode("回访方式 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createVNode(_component_el_select, {
          modelValue: visitForm.visitType,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => visitForm.visitType = $event),
          class: "form-select w-full"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "电话",
            value: 0
          }), _createVNode(_component_el_option, {
            label: "微信",
            value: 1
          }), _createVNode(_component_el_option, {
            label: "上门",
            value: 2
          }), _createVNode(_component_el_option, {
            label: "邮件",
            value: 3
          }), _createVNode(_component_el_option, {
            label: "其他",
            value: 4
          })]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_91, [_cache[73] || (_cache[73] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, [_createTextVNode("回访内容 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => visitForm.content = $event),
          rows: "4",
          class: "form-textarea",
          placeholder: "请输入回访内容"
        }, null, 512), [[_vModelText, visitForm.content]])]), _createElementVNode("div", _hoisted_92, [_cache[74] || (_cache[74] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, "回访时间", -1)), _createVNode(_component_el_date_picker, {
          modelValue: visitForm.visitTime,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => visitForm.visitTime = $event),
          type: "datetime",
          class: "form-date",
          format: "YYYY年MM月DD日 HH:mm",
          "value-format": "YYYY-MM-DD HH:mm:ss",
          placeholder: "请选择回访时间"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_93, [_cache[75] || (_cache[75] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, "问题/需求记录", -1)), _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => visitForm.issues = $event),
          rows: "2",
          class: "form-textarea",
          placeholder: "请输入问题和需求"
        }, null, 512), [[_vModelText, visitForm.issues]])]), _createElementVNode("div", _hoisted_94, [_cache[76] || (_cache[76] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, "下次回访时间", -1)), _createVNode(_component_el_date_picker, {
          modelValue: visitForm.nextVisitTime,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => visitForm.nextVisitTime = $event),
          type: "datetime",
          class: "form-date",
          format: "YYYY年MM月DD日 HH:mm",
          "value-format": "YYYY-MM-DD HH:mm:ss",
          placeholder: "请选择下次回访时间"
        }, null, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_95, [_createElementVNode("button", {
          type: "button",
          onClick: _cache[13] || (_cache[13] = $event => showVisitModal.value = false),
          class: "btn-secondary"
        }, "取消"), _createElementVNode("button", {
          type: "button",
          onClick: handleCreateVisit,
          disabled: visitSubmitting.value,
          class: "btn-primary"
        }, [visitSubmitting.value ? (_openBlock(), _createElementBlock("svg", _hoisted_97, [...(_cache[77] || (_cache[77] = [_createElementVNode("circle", {
          class: "opacity-25",
          cx: "12",
          cy: "12",
          r: "10",
          stroke: "currentColor",
          "stroke-width": "4"
        }, null, -1), _createElementVNode("path", {
          class: "opacity-75",
          fill: "currentColor",
          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        }, null, -1)]))])) : _createCommentVNode("", true), _cache[78] || (_cache[78] = _createTextVNode(" 保存 ", -1))], 8, _hoisted_96)])]),
        _: 1
      }, 8, ["visible"])]))]);
    };
  }
};